import React, { useState } from 'react';
import { Switch } from 'antd';

import useFetchPermissions from './useFetchPermissions';
import UserPermissions from '../Service/UsersPermission';
import Swal from 'sweetalert2';

const columns = [
	{
		title: 'Permissions',
		dataIndex: 'check1',
		key: 'check1'
	},
	{
		title: 'Admin',
		dataIndex: 'check2',
		key: 'check2'
	},
	{
		title: 'Customer Service',
		dataIndex: 'check3',
		key: 'check3'
	},
	{
		title: 'Commercial',
		dataIndex: 'check4',
		key: 'check4'
	},
	{
		title: 'Accounting',
		dataIndex: 'check5',
		key: 'check5'
	}
];

const usePermissionItemsTable = () => {
	const { state } = useFetchPermissions();
	const [updateLoader, setUpdateLoader] = useState(false);

	const sortOptions = (a, b) => {
		if (a.permissions < b.permissions) {
			return -1;
		}
		if (a.permissions > b.permissions) {
			return 1;
		}
		return 0;
	};

	const handleChange = async (data, role, checked) => {
		try {
			setUpdateLoader(true);

			const response = await UserPermissions.getAllPermissions();
			const prevValues = response.filter(m => m.id === data.id);

			const { admin, customer_service, commercial, accounting } = prevValues[0];

			const payloadtest = { admin, customer_service, commercial, accounting };

			await UserPermissions.updatePermissions(data.id, {
				...payloadtest,

				[role]: checked
			});
			setUpdateLoader(false);
		} catch (error) {
			setUpdateLoader(false);
			toastWhenFail(`Error: ${error.message}`);
		}
	};

	const toastWhenFail = resp => {
		Swal.fire({
			allowOutsideClick: false,
			title: 'Something went wrong!',
			text: resp,
			imageUrl: 'https://cdn-icons-png.flaticon.com/512/5219/5219070.png',
			imageAlt: 'Custom Image',
			// icon: 'error',
			customClass: 'otp_message_success'
		});
	};

	const data = state?.result?.sort(sortOptions).map(data => ({
		key: data.id,
		check1: data.permissions,
		check2: (
			<div>
				<Switch
					size="small"
					defaultChecked={data.admin}
					checkedChildren="on"
					unCheckedChildren="off"
					loading={updateLoader}
					onChange={checked => handleChange(data, 'admin', checked)}
				/>
			</div>
		),
		check3: (
			<div>
				<Switch
					size="small"
					defaultChecked={data.customer_service}
					checkedChildren="on"
					unCheckedChildren="off"
					loading={updateLoader}
					onChange={checked => handleChange(data, 'customer_service', checked)}
				/>
			</div>
		),
		check4: (
			<div>
				<Switch
					size="small"
					defaultChecked={data.commercial}
					checkedChildren="on"
					unCheckedChildren="off"
					loading={updateLoader}
					onChange={checked => handleChange(data, 'commercial', checked)}
				/>
			</div>
		),
		check5: (
			<div>
				<Switch
					size="small"
					defaultChecked={data.accounting}
					checkedChildren="on"
					unCheckedChildren="off"
					loading={updateLoader}
					onChange={checked => handleChange(data, 'accounting', checked)}
				/>
			</div>
		)
	}));

	return { data, columns };
};

export default usePermissionItemsTable;
